<template>
  <div class="pageStyle">
    <div class="header">
      <div class="search">
        <van-search
          v-model="searchParams.companyNameLike"
          shape="round"
          show-action
          placeholder="请输入企业名称"
        >
          <template #action>
            <div class="searchBtn" @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="queryOptions">
        <!-- 第一行快捷选项 -->
        <div class="item">
          <div class="left">
            <div
              v-for="(item, index) in locationFilters"
              :key="index"
              @click="handleLocationFilter(index)"
            >
              <span>{{ item.label }}</span>
              <van-icon
                v-show="!item.showCloseFlag"
                name="arrow-down"
                size="3.2vw"
              />
              <van-icon
                v-show="item.showCloseFlag"
                name="clear"
                size="3.2vw"
                @click.stop="clearLocationFilter(index)"
              />
            </div>
          </div>
          <div
            class="right"
            @click="isMoreFilterVisible = !isMoreFilterVisible"
          >
            <div v-if="!isMoreFilterVisible">
              <span>更多条件</span><van-icon name="arrow-down" size="3.6vw" />
            </div>
            <div v-else>
              <span>收起</span><van-icon name="arrow-up" size="3.6vw" />
            </div>
          </div>
        </div>
        <!-- 第二行快捷选项 -->
        <div class="item" v-show="isMoreFilterVisible">
          <div
            v-for="(item, index) in advancedFilters"
            :key="index"
            @click="handleAdvancedFilter(index)"
            class="block"
          >
            <span>{{ item.label }}</span>
            <van-icon
              v-show="!item.showCloseFlag"
              name="arrow-down"
              size="3.2vw"
            />
            <van-icon
              v-show="item.showCloseFlag"
              name="clear"
              size="3.2vw"
              @click.stop="clearAdvancedFilter(index)"
            />
          </div>
        </div>
        <!-- 第三行输入选项 -->
        <div class="item" v-show="isMoreFilterVisible">
          <div class="row">
            <span>年开票额：</span>
            <van-field
              type="digit"
              clearable
              v-model="searchParams.invoiceSum"
              placeholder="请输入"
            />
            <span>万</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-if="companyList.length" class="companyList">
          <company-item
            v-for="(item, index) in companyList"
            :key="index"
            :company="item"
            @convert="convertToCustomer"
          />
        </div>
        <!-- <div v-else class="empty-state">暂无数据</div> -->
      </van-list>
    </div>
    <!-- 第二行选择弹窗 -->
    <van-popup
      v-for="(item, index) in advancedFilters"
      :key="index + 'row2'"
      v-model="item.popupShow"
      position="bottom"
      round
    >
      <div class="popupDiv">
        <div class="popupDiv-content">
          <van-picker
            :title="'选择' + item.label"
            value-key="label"
            show-toolbar
            :columns="item.data"
            @confirm="popupConfirm2($event, index)"
            @cancel="item.popupShow = !item.popupShow"
          />
        </div>
      </div>
    </van-popup>
    <!-- 地区选择 -->
    <van-popup v-model="isAreaPickerVisible" position="bottom">
      <van-area
        :columns-num="areaPickerLevel"
        title="选择地区"
        :area-list="areaList"
        @confirm="handleAreaConfirm"
        @cancel="isAreaPickerVisible = !isAreaPickerVisible"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { areaList } from "@vant/area-data";
import { parseTime } from "@/utils/index.js";
import { getCompanyList } from "@/api/companyInfo";
import CompanyItem from "./components/CompanyItem.vue";
import { addCustomer } from "@/api/xcCustomer";
import {
  Icon,
  Toast,
  Search,
  List,
  Calendar,
  Popup,
  Picker,
  Field,
  Button,
  Area,
  Notify,
} from "vant";
Vue.use(Field);
Vue.use(Icon);
Vue.use(Search);
Vue.use(List);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Calendar);
Vue.use(Area);
export default {
  name: "AccurateSearch",
  components: {
    CompanyItem,
  },

  data() {
    return {
      isMoreFilterVisible: false,
      locationFilters: [
        {
          label: "省份",
          showCloseFlag: false,
          popupShow: false,
        },
        {
          label: "城市",
          showCloseFlag: false,
          popupShow: false,
        },
      ],
      advancedFilters: [
        {
          value: "taxRatingPopup",
          label: "纳税评级",
          showCloseFlag: false,
          data: [
            { label: "A", value: "A" },
            { label: "B", value: "B" },
            { label: "C", value: "C" },
          ],
          popupShow: false,
        },
        {
          value: "isGXQYPopup",
          label: "专精特新",
          showCloseFlag: false,
          data: [{ label: "是", value: "true" }],
          popupShow: false,
        },
      ],
      searchParams: {
        province: "",
        city: "",
        invoiceSum: "",
        taxLevel: "",
        companyName: "",
        isZjtx: "",
        isSeaQueryModel: true,
      },
      companyList: [],
      isAreaPickerVisible: false,
      isGXQYPickerVisible: false,
      isNoOption: [{ label: true, value: "是" }],
      areaPickerLevel: 2,
      areaList,
      loading: false,
      finished: false,
      page: 0,
      size: 10,
    };
  },

  mounted() {},

  methods: {
    parseTime,
    convertToCustomer(id) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      addCustomer({
        enterpriseId: id,
        resourceType: "development",
      })
        .then((res) => {
          console.log("res", res);
          Toast.clear();
          Notify({ type: "success", message: "添加成功" });
          this.onSearch();
          console.log("res", res);
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    async onSearch() {
      if (this.searchParams.invoiceSum) {
        this.searchParams.invoiceSum = this.searchParams.invoiceSum * 1;
      }
      this.page = 0;
      this.finished = false;
      this.companyList = [];
      await this.loadData();
    },
    async onLoad() {
      await this.loadData();
    },
    async loadData() {
      try {
        this.loading = true;
        const params = {
          page: this.page,
          size: this.size,
          sort: "id,desc",
        };

        Object.entries(this.searchParams).forEach(([key, value]) => {
          if (value !== null && value !== "") {
            params[key] = value;
          }
        });

        const res = await getCompanyList(params);
        const { content, totalElements } = res;
        this.companyList.push(...content);

        if (this.companyList.length >= totalElements || content.length === 0) {
          this.finished = true;
        }
        this.page++;
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$toast.fail("加载数据失败");
        this.finished = true;
      } finally {
        this.loading = false;
      }
    },
    // 第一行快捷选项 点击 显示弹窗事件
    handleLocationFilter(index) {
      if (index === 0) {
        this.areaPickerLevel = 1;
      }
      if (index === 1) {
        this.areaPickerLevel = 2;
      }
      this.isAreaPickerVisible = true;
    },
    // 第二行快捷选项 点击 显示弹窗事件
    handleAdvancedFilter(index) {
      this.advancedFilters[index].popupShow = true;
    },
    // 第二行快捷选项 弹窗确认事件
    popupConfirm2(e, index) {
      if (index === 0) {
        this.advancedFilters[index].label = "纳税评级：" + e.label;
        this.searchParams.taxLevel = e.value;
      }
      if (index === 1) {
        this.advancedFilters[index].label = "专精特新：是";
        this.searchParams.isZjtx = true;
        this.isGXQYPickerVisible = false;
      }
      this.advancedFilters[index].popupShow = false;
      this.advancedFilters[index].showCloseFlag = true;
    },
    // 第一行快捷选项 点击清除按钮事件
    clearLocationFilter(index) {
      this.locationFilters[index].showCloseFlag = false;
      if (index == 0) {
        this.locationFilters[index].label = "省份";
        this.searchParams.province = "";
      }
      if (index == 1) {
        this.locationFilters[index].label = "城市";
        this.searchParams.city = "";
      }
    },
    // 第二行快捷选项 点击清除按钮事件
    clearAdvancedFilter(index) {
      this.advancedFilters[index].showCloseFlag = false;
      if (index === 0) {
        this.advancedFilters[index].label = "纳税评级";
        this.searchParams.taxLevel = "";
      }
      if (index === 1) {
        this.advancedFilters[index].label = "专精特新";
        this.searchParams.isZjtx = "";
      }
    },
    // 第一行快捷选项 选择地区 确认事件
    handleAreaConfirm(e) {
      if (this.areaPickerLevel === 1) {
        this.$set(this.locationFilters[0], "label", e[0].name);
        this.$set(this.locationFilters[1], "label", "城市");
        this.$set(this.locationFilters[0], "showCloseFlag", true);
        this.$set(this.locationFilters[1], "showCloseFlag", false);
        this.searchParams.city = "";
        this.searchParams.province = e[0].name;
      }
      if (this.areaPickerLevel === 2) {
        this.$set(this.locationFilters[0], "label", e[0].name);
        this.$set(this.locationFilters[1], "label", e[1].name);
        this.$set(this.locationFilters[0], "showCloseFlag", true);
        this.$set(this.locationFilters[1], "showCloseFlag", true);
        this.searchParams.province = e[0].name;
        this.searchParams.city = e[1].name;
      }
      this.isAreaPickerVisible = false;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/customerCenter/module/accurateSearch/index.vue